class Video {
  public videos: NodeListOf<HTMLVideoElement> | null;

  cache() {
    this.videos = document.querySelectorAll('.js-responsive-video');
  }

  bindings() {
    if (this.videos) {
      this.videos.forEach((video: HTMLVideoElement) => {
        this.setVideoSource(video);

        window.addEventListener('resize', () => {
          this.setVideoSource(video);
        });
      });
    }
  }

  setVideoSource(video: HTMLVideoElement) {
    const mobileVideoUrl = video.dataset.srcMobile as string;
    const desktopVideoUrl = video.dataset.srcDesktop as string;

    if (window.innerWidth > 768 && desktopVideoUrl && video.src !== desktopVideoUrl) {
      video.pause();
      video.src = desktopVideoUrl;
      video.play();
    } else if (window.innerWidth < 768 && mobileVideoUrl && video.src !== mobileVideoUrl) {
      video.pause();
      video.src = mobileVideoUrl;
      video.play();
    } else if (!mobileVideoUrl) {
      video.pause();
      video.src = desktopVideoUrl;
      video.play();
    }
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default Video;
